export default {
    manage_deleteWorkOrder_title: "Eliminar Orden de Trabajo",
    manage_deleteWorkOrders_title: "Eliminar Órdenes de Trabajo",
    manage_deleteWorkOrders_description: "¿Estás seguro de que quieres eliminar las Órdenes de Trabajo?",
    manage_deleteWorkOrder_description: "¿Estás seguro de que quieres eliminar esta Orden de Trabajo?",
    manage_deleteWorkOrder_successMessage: "Orden de Trabajo eliminada",
    manage_deleteWorkOrders_successMessage: "Órdenes de Trabajo eliminadas",
    manage_deleteWorkOrders_are_in_use: "No es posible eliminar órdenes de trabajo en uso",
}